import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appCustomDetailFilter]',
  standalone: true,
})
export class CustomDetailFilterDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
